import { Component, Input } from '@angular/core';
import { FormBase } from '../../../_classes/form-base.class';
import IProductCategory from '../../../_interfaces/IProductCategory';
import { Observable } from 'rxjs';
import { ProductsCategoriesService } from '../../../_services/products/products-categories.service';
import { MessageService } from 'primeng/api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SessionService } from '../../../_services/session/session.service';
import { ValidatorService } from '../../../_services/validators/validator.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { EResources } from '../../../_resources/EResources';
import { AdminFormActionsComponent } from '../../admin-ui/admin-form-actions/admin-form-actions.component';

@Component({
  selector: 'app-form-category-products',
  imports: [
    TranslatePipe,

    FormsModule,
    CommonModule,
    ButtonModule,
    InputTextModule,
    AdminFormActionsComponent,
  ],
  templateUrl: './form-category-products.component.html',
  styleUrl: './form-category-products.component.scss',
})
export class FormCategoryProductsComponent extends FormBase<IProductCategory> {
  @Input() showIntro = true;
  public submitting = false;

  constructor(
    public productsCategoriesService: ProductsCategoriesService,
    public messageService: MessageService,
    public validateService: ValidatorService,
    public translate: TranslateService,
    public session: SessionService
  ) {
    super(session, messageService, translate);
  }

  clear(): void {
    this.payload = {
      name: undefined,
    };
  }
  generatePayload(): IProductCategory {
    return {
      name: this.payload.name,
    };
  }
  getResourceName(): string {
    return EResources.PRODUCTS_CATEGORIES;
  }
  updateFn(payload: IProductCategory): Observable<any> {
    return this.productsCategoriesService.update(
      this.customers_id,
      this.id,
      payload
    );
  }
  createFn(payload: IProductCategory): Observable<any> {
    return this.productsCategoriesService.create(this.customers_id, payload);
  }
  properties(): string[] {
    return ['name'];
  }
  validate(): Promise<void> {
    return this.validateService.productCategory(this.payload);
  }

  override async execute(): Promise<void> {
    this.submitting = true;
    try {
      await super.execute();
    } finally {
      this.submitting = false;
    }
  }

  get formTitleKey(): string {
    return this.mode === 'edit'
      ? 'ADMIN.PRODUCTS.ALL.CATEGORIES'
      : 'ADMIN.PRODUCTS.ADD.CATEGORIES';
  }

  get formDescriptionKey(): string {
    return 'ADMIN.IA.PRODUCTS.DESCRIPTION';
  }
}
